import { ICluster, IContact, ILogisticsProvider, ICenter, IListItem, IRccapRootCause, ITransportType, ICenterToCenterDistance } from "../../models";

export interface ISwapState {
    clusterStatusId: number;
    chainStatusId: number;
    list: ICluster[];
    centerList: ICenter[];
    chainStatusList: IListItem[];
    clusterStatusList: IListItem[];
    logisticsProviders: ILogisticsProvider[];
    pairStatusList: IListItem[];
    staffList: IContact[];
    transportTypeList: ITransportType[];
    swapTypeList: IListItem[];
    distanceBetweenCenters: ICenterToCenterDistance[],
    rccapPhaseList: IListItem[];
    rccapAvoidableList: IListItem[];
    rccapBillableList: IListItem[];
    rccapCauseList: IRccapRootCause[];
    rccapCorrectiveActionList: IListItem[];
    rccapSatisfactoryResponseList: IListItem[];
}
